<template>
  <div class="smsSendTotal">
    <div class="p16 sms_head align-items mb10 br10">
      <div>
        <div class="sms_title">短信统计</div>
        <div>
          <el-date-picker v-model="reportMonth" type="month" value-format="yyyy-MM" placeholder="选择月" :clearable="false"></el-date-picker>
          <el-button class="ml10" @click="init">搜索</el-button>
        </div>
      </div>
      <el-button type="primary" @click="skipDetail">查看详情</el-button>
    </div>
    <div class="">
      
      <div class="mains-content br10 mb10">
        <div class="space-between">
          <p class="order-title-boxs mtb20"><span class="blueBlock"></span><i>短信余量</i></p>
        </div>
        <div class="align-items total_box">
          <div class="item">
            <div class="item-title">当前剩余</div>
            <div class="item-num">{{totalAmount || 0}}条</div>
          </div>
          <el-button class="ml30" size="small" @click="skipSms">订购</el-button>
        </div>
      </div>
      <div class="mains-content br10">
        <div class="space-between">
          <p class="order-title-boxs mtb20"><span class="blueBlock"></span><i>短信统计</i></p>
        </div>
        <div class="align-item total_box">
          <div class="item">
            <div class="item-title">发送总数</div>
            <div class="item-num">{{form.sendTotal}}条</div>
          </div>
          <div class="item">
            <div class="item-title">短信订购</div>
            <div class="item-num">{{form.rechargeTotal}}条</div>
          </div>
          <div class="item">
            <div class="item-title">短信赠送</div>
            <div class="item-num">{{form.giveTotal}}条</div>
          </div>
          <div class="item">
            <div class="item-title">发送失败</div>
            <div class="item-num">{{form.failTotal}}条</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import config from "./config/colums";
export default {
  mixins: [minxin],
  components: {},
  data() {
    return {
      columns: config.detail,
      totalAmount: 0,
      form: {},
      list: [],
      reportMonth: '',
      height: this.$store.getters.MainHeight
    };
  },
  created() {
    this.reportMonth = this.formatMonth(new Date())
    this.init();
  },
  mounted () {},
  methods: {
    async init () {
      let res = await this.$api.post(this.$url.smsStatisticsDay.get, {reportMonth: this.reportMonth})
      let ret = await this.$api.post(this.$url.smsStatisticsDay.getSmsLeftNum, {reportMonth: this.reportMonth})
      if (res) this.form = res;
      if (ret) this.totalAmount = ret;
    },
    skipDetail () {
      this.$router.push({
        path: "/manage/smsSendDetail",
        query: {
          reportMonth: this.form.reportMonth
        }
      })
    },
    skipSms () {
      this.$router.push('/manage/shopServeed?type=sms')
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";
.member-content-box {
  background: #fff;
}
.page-head {
  height: 100%;
}
.mains-content {
  background: #fff;
}
.smsSendTotal {
  padding: 16px;
  .sms_head {
    background: #fff;
    .sms_title {
      font-style: normal;
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 20px;
    }
  }
}
.total_box {
  width: max-content;
  padding-bottom: 20px;
  .item {
    margin-left: 30px;
    
    text-align: center;
    .item-title {
      font-size: 14px;
      color: #aaa;
    }
    .item-num {
      color: #000000;
      font-weight: 700;
      font-size: 20px;
    }
  }
}
</style>
